export default {
    api: 'https://api.martendenheijer.nl/reflection-backend/v1',
    // api: 'http://localhost:8001',
    memoryLabelId: 1,
    noteLabelId: 2
}


// WEBPACK FOOTER //
// ./src/config/index.js